import { getAccessToken, isLoggedIn } from 'axios-jwt'
import { getPermissionProfile } from '@/http'
import { hasPermission } from '@/utils/permissionSelection'
import { tokenSubject } from '@/utils/permissionAccess'

let pending = null
let pendingSubject = null

export default {
  namespaced: true,
  state: () => ({ keys: [], profileSubject: null, generation: 0, catalogVersion: null }),
  getters: {
    can: state => key => hasPermission(state, key)
  },
  mutations: {
    reset(state) {
      state.keys = []
      state.profileSubject = null
      state.catalogVersion = null
      state.generation += 1
      pending = null
      pendingSubject = null
    },
    set(state, { authorization, subject }) {
      state.keys = authorization?.permissions || []
      state.profileSubject = subject
      state.catalogVersion = authorization?.catalog_version || null
    }
  },
  actions: {
    async refreshProfile({ state, commit, rootState }, force = false) {
      if (!isLoggedIn()) {
        commit('reset')
        return null
      }
      const subject = tokenSubject(getAccessToken())
      if (!subject) {
        commit('reset')
        return null
      }
      if (state.profileSubject && state.profileSubject !== subject) commit('reset')
      if (!force && state.profileSubject === subject) return rootState.userData
      if (pending && pendingSubject === subject) return pending
      const generation = state.generation
      const request = getPermissionProfile().then(response => {
        if (generation !== state.generation || !subject || subject !== tokenSubject(getAccessToken()) || !isLoggedIn()) return null
        commit('set', { authorization: response.data.authorization, subject })
        commit('setUserData', response.data, { root: true })
        commit('setUserGroups', response.data.groups, { root: true })
        return response.data
      }).catch(error => {
        if (generation === state.generation && subject === tokenSubject(getAccessToken())) commit('reset')
        throw error
      }).finally(() => {
        if (pending === request) {
          pending = null
          pendingSubject = null
        }
      })
      pending = request
      pendingSubject = subject
      return request
    }
  }
}
